var React = require('react');

function FlagSweden (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.5 0H24.5V15H0.5V0Z","fill":"#006AA7","key":0}),React.createElement("path",{"d":"M0.5 6H8V0H11V6H24.5V9H11V15H8V9H0.5V6Z","fill":"#FECC00","key":1})]);
}

FlagSweden.defaultProps = {"width":"25","height":"15","viewBox":"0 0 25 15","fill":"none"};

module.exports = FlagSweden;

FlagSweden.default = FlagSweden;
